import { Helmet } from "react-helmet";

export const SEOHead = ({ 
  title = "24/7 Car Recovery Hackney | Emergency Breakdown Service East London | Ovawell Autos",
  description = "Fast 30-min car recovery & vehicle transport in Hackney, East London. 24/7 emergency breakdown, auction transport, jump start service. Call 07492 639223 for immediate help.",
  keywords = "car recovery hackney, breakdown service east london, emergency car recovery, vehicle transport hackney, car towing hackney, 24/7 breakdown recovery, auction car transport london, jump start service hackney, roadside assistance east london, car recovery near me",
  canonical = "https://www.ovawellautosltd.co.uk"
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:locale" content="en_GB" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="GB-LON" />
      <meta name="geo.placename" content="Hackney, East London" />
      <meta name="geo.position" content="51.5450;-0.0553" />
      <meta name="ICBM" content="51.5450, -0.0553" />
      
      {/* Robots Meta Tags */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      
      {/* Local Business Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AutoRepair",
          "name": "Ovawell Autos Ltd",
          "description": "24/7 Car Recovery and Vehicle Transport Service in Hackney, East London",
          "url": canonical,
          "telephone": "+447492639223",
          "email": "ovawellautoslimited@outlook.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Hackney",
            "addressLocality": "Hackney",
            "addressRegion": "East London",
            "postalCode": "E8",
            "addressCountry": "GB"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "51.5450",
            "longitude": "-0.0553"
          },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday"
            ],
            "opens": "00:00",
            "closes": "23:59"
          },
          "priceRange": "££",
          "areaServed": [
            {
              "@type": "City",
              "name": "Hackney"
            },
            {
              "@type": "City",
              "name": "East London"
            },
            {
              "@type": "City",
              "name": "Shoreditch"
            },
            {
              "@type": "City",
              "name": "Stratford"
            },
            {
              "@type": "City",
              "name": "Bethnal Green"
            },
            {
              "@type": "City",
              "name": "Islington"
            }
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Car Recovery Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "24/7 Emergency Breakdown Recovery",
                  "description": "Emergency breakdown recovery service across Hackney and East London with 30-minute response time",
                  "areaServed": "Hackney, East London"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Car Auction Transport",
                  "description": "Vehicle collection from auction houses and delivery across East London",
                  "areaServed": "East London, Essex"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Vehicle Transportation",
                  "description": "Professional car transportation for running and non-running vehicles in Hackney area",
                  "areaServed": "Hackney, East London, 20-mile radius"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Jump Start Service",
                  "description": "Fast jump start service for dead batteries across East London",
                  "areaServed": "Hackney, East London"
                }
              }
            ]
          },
          "sameAs": []
        })}
      </script>
    </Helmet>
  );
};
